'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  label: string;
  value: string;
}

interface FilterBarProps {
  categories: FilterOption[];
  industries: FilterOption[];
  selectedCategory: string;
  selectedIndustry: string;
  searchQuery: string;
  onCategoryChange: (value: string) => void;
  onIndustryChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onReset: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  categories,
  industries,
  selectedCategory,
  selectedIndustry,
  searchQuery,
  onCategoryChange,
  onIndustryChange,
  onSearchChange,
  onReset,
}) => {
  return (
    <div className="bg-card rounded-xl shadow-subtle p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Icon
            name="MagnifyingGlassIcon"
            size={20}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary"
          />
          <input
            type="text"
            placeholder="Search projects..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 bg-muted border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
          />
        </div>

        <div className="relative">
          <Icon
            name="FolderIcon"
            size={20}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary pointer-events-none"
          />
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full pl-10 pr-10 py-2.5 bg-muted border border-border rounded-lg text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300 cursor-pointer"
          >
            {categories.map((category) => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
          <Icon
            name="ChevronDownIcon"
            size={16}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary pointer-events-none"
          />
        </div>

        <div className="relative">
          <Icon
            name="BuildingOfficeIcon"
            size={20}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary pointer-events-none"
          />
          <select
            value={selectedIndustry}
            onChange={(e) => onIndustryChange(e.target.value)}
            className="w-full pl-10 pr-10 py-2.5 bg-muted border border-border rounded-lg text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300 cursor-pointer"
          >
            {industries.map((industry) => (
              <option key={industry.value} value={industry.value}>
                {industry.label}
              </option>
            ))}
          </select>
          <Icon
            name="ChevronDownIcon"
            size={16}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary pointer-events-none"
          />
        </div>

        <button
          onClick={onReset}
          className="px-4 py-2.5 bg-muted text-text-primary rounded-lg font-medium text-sm hover:bg-border transition-all duration-300 flex items-center justify-center gap-2"
        >
          <Icon name="ArrowPathIcon" size={16} />
          <span>Reset Filters</span>
        </button>
      </div>
    </div>
  );
};

export default FilterBar;